import React, { memo } from 'react';

import PropTypes from 'prop-types';

import { CircularProgress, Box } from '@mui/material';

const LoaderBox = ({ loading, error, success, errorMessage, successMessage }) => {
  return (
    <Box
      sx={{
        m: 1,
      }}
    >
      {loading && <CircularProgress size={60} thickness={5} />}

      {!loading &&
        ((error && (
          <Box
            sx={{
              color: 'secondary.main',
            }}
          >
            {errorMessage}
          </Box>
        )) ||
          (success && (
            <Box
              sx={{
                color: 'primary.main',
              }}
            >
              {successMessage}
            </Box>
          )))}
    </Box>
  );
};

LoaderBox.propTypes = {
  loading: PropTypes.bool,
  error: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  success: PropTypes.bool,
  errorMessage: PropTypes.any,
  successMessage: PropTypes.any,
};

LoaderBox.defaultProps = {};

export default memo(LoaderBox);
